import { ProcessorSwitch } from '../../atoms/processor-switch';
import { SelectTerminalJustifi } from './select-terminal-justifi';
import { SelectTerminalStripe } from './select-terminal-stripe';

export const SelectTerminalSwitch = () => {
  return <ProcessorSwitch stripeContent={SelectTerminalStripe} justifiContent={SelectTerminalJustifi} />;
};
